import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { client_v2 } from "utils/api";
import getStatus from "pages/completing/Packs/const/getStatus";
import { Select } from "expano-components";
import { Loader } from "components";

const CartPanel = () => {
  const { isLoading, isFetching, data, refetch } = useQuery(
    ["dashboard_carts"],
    () => client_v2.get("/stats/dashboard_carts"),
    {
      select: (res) => res.data,
      retry: false,
    },
  );
  const is_loading = isLoading || isFetching;
  const [type, setType] = useState("all");
  const options = [
    { label: "Wszystkie", value: "all" },
    { label: "BOX_1", value: "box_1" },
    { label: "BOX_4", value: "box_4" },
    { label: "BOX_6", value: "box_6" },
    { label: "BOX_12", value: "box_12" },
    { label: "BOX_24", value: "box_24" },
  ];

  const cart_data = data?.filter(({ box_size }) => {
    if (type === "all") return true;
    return box_size === type;
  });

  return (
    <div className="dashboard cart-box">
      <div className="dashboard__header">
        <h2 className="dashboard__title heading">Wózki</h2>
        {is_loading ? (
          <Loader size="20" />
        ) : (
          <div style={{ flexBasis: 260 }}>
            <Select
              options={options}
              handleChange={(value) => setType(value)}
              value={options.find(({ value }) => value === type)}
            />
            <button className="btn btn-default" onClick={refetch}>
              Odśwież
            </button>
          </div>
        )}
      </div>
      <table className="table table-sm">
        <thead className="table__header">
          <tr>
            <th width="25%">ID</th>
            <th width="25%">Pack</th>
            <th width="25%">Picker</th>
            <th width="25%">Packer</th>
          </tr>
        </thead>
        <tbody className="table__body">
          {cart_data
            ?.sort((a, b) => a.id - b.id)
            .map(
              ({
                id,
                box_size,
                gdn_pack_id,
                gdn_return_pack_id,
                gdn_return_handler_name,
                gdn_pack_status,
                picker_name,
                packer_name,
                gdns_total_count,
                gdns_picked_count,
                gdns_packed_count,
                gdn_pack_prepared_at,
                picker_is_pieceworker,
                packer_is_pieceworker,
                is_occupied,
                is_fast_shipment,
              }) => (
                <tr key={id}>
                  <td>
                    <p>
                      {id}
                      {is_occupied && (
                        <span
                          className="label label--danger m-l-5"
                          style={{
                            padding: "2px 4px",
                          }}
                        >
                          <span className="text-10">Zajęty</span>
                        </span>
                      )}
                      {gdn_return_pack_id && (
                        <span
                          className="label label--info m-l-5"
                          style={{
                            padding: "2px 4px",
                          }}
                        >
                          <span className="text-10">Zwroty</span>
                        </span>
                      )}
                    </p>
                    <p className="text-11">{box_size}</p>
                  </td>
                  <td>
                    {gdn_pack_id ? (
                      <>
                        <a
                          target="_blank"
                          rel="noopener noreferrer"
                          href={`/packing/gdn_pack/${gdn_pack_id}`}
                        >
                          {gdn_pack_id}
                        </a>

                        {gdn_pack_prepared_at ? (
                          <p>{gdn_pack_prepared_at}</p>
                        ) : null}
                        {gdn_pack_status && (
                          <p>
                            <span
                              className={`label label--${
                                getStatus(gdn_pack_status).color
                              }`}
                              style={{
                                padding: "2px 4px",
                              }}
                            >
                              <span className="text-10">
                                {getStatus(gdn_pack_status).name}
                              </span>
                            </span>
                          </p>
                        )}
                        {is_fast_shipment && (
                          <p>
                            <span
                              className={`label label--danger`}
                              style={{
                                padding: "2px 4px",
                              }}
                            >
                              <span className="text-10">Szybka wysyłka</span>
                            </span>
                          </p>
                        )}
                      </>
                    ) : gdn_return_pack_id ? (
                      <p>{gdn_return_pack_id}</p>
                    ) : (
                      <p className="text-11">brak</p>
                    )}
                  </td>
                  <td>
                    <p>
                      {picker_name || gdn_return_handler_name || "-"}{" "}
                      {picker_name && picker_is_pieceworker && (
                        <span
                          class="label label--danger"
                          style={{ padding: "2px 4px" }}
                        >
                          <span class="text-10">A</span>
                        </span>
                      )}
                    </p>
                    {gdns_total_count ? (
                      <p className="text-11">
                        {gdns_picked_count || 0}/{gdns_total_count || "-"}
                      </p>
                    ) : null}
                  </td>
                  <td>
                    <p>
                      {packer_name || "-"}{" "}
                      {packer_name && packer_is_pieceworker && (
                        <span
                          class="label label--danger"
                          style={{ padding: "2px 4px" }}
                        >
                          <span class="text-10">A</span>
                        </span>
                      )}
                    </p>
                    {gdns_total_count ? (
                      <p className="text-11">
                        {gdns_packed_count || 0}/{gdns_total_count || "-"}
                      </p>
                    ) : null}
                  </td>
                </tr>
              ),
            )}
        </tbody>
      </table>
    </div>
  );
};

export default CartPanel;
